import styled from '@emotion/styled';
import { breakpoints } from '~/theme';
import { smCondition, xsCondition } from '~/theme/lib/breakpoints';

export const StyledProductList = styled.div(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: `repeat(${theme.productCard.cardsPerRow.xs}, 1fr)`,
	gridAutoFlow: 'dense',
	width: '100%',
	gap: `${theme.space[5]} ${theme.space[2]}`,
	boxSizing: 'border-box',

	[breakpoints.md]: {
		gridTemplateColumns: `repeat(${theme.productCard.cardsPerRow.sm}, 1fr)`,
	},

	[breakpoints.lg]: {
		gap: `${theme.space[7]} ${theme.space[4]}`,
		gridTemplateColumns: `repeat(${theme.productCard.cardsPerRow.lg}, 1fr)`,
	},
}));

export const imageSizes = [`${xsCondition} 100vw`, `${smCondition} 33vw`, '25vw'].join(',');
